import gameiomModel from "gameiom/model/gameiom-model";
import PaytableComponent from "slotworks/components/paytable/paytable-component";
import { Services } from "slotworks/services/services";

interface ReplaceWord {
    [index: number]: {[key: string]: string};
}

interface PageWord {
    change: ReplaceWord[];
    page: number;
}

export default class AgsPaytableComponent extends PaytableComponent {

    private replaceWords: any = [{page: 9, change: [{_1: "gam.help_no_jp"}]}];

    protected update() {
        super.update();
        const result = this.getChangedText();
        if ( gameiomModel.hideJackpotWording && result && result.change) {
            this.changeText(result.change);
        }
    }

    private getChangedText() {
        const changedText = this.replaceWords.filter((words: PageWord) => words.page === this.page);
        return changedText[0];
    }

    private changeText(texts: ReplaceWord[]) {

        for (const field of texts) {
            for (const key in field) {
                if (field.hasOwnProperty(key)) {
                    const currentText = this.contentLayer.getText(`page_${this.page + 1}${key}`);
                    if (currentText) {
                        currentText.text = Services.translations.get(`${field[key]}`);
                    }
                }
            }
        }
    }
}
